// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2ENKW","icon":"Loader_icon__3gY1S"};